export const Nine = 'Z';